import { analyticsTrack, MATCH_LINEUPS_FIELDS_WIDGET_TRACKING_KEY } from './analytics-track';

/** Components tracking flags */
let isLineupsTracked = false;

/* consts */
const FORMATIONS_TAB = '/formazioni';

const matchLineupsFieldsWidgetTag = 'ld-football-lmp-lineups'

const isFormationsTabActive = () => location.href.match(`.*${FORMATIONS_TAB}$`); // RegEx: ENDS WITH '/formazioni'

/**
 * Track components in Tabs body
 * - teams Lineups
 */

export const trackComponentsInTabs = async () => {
  if (!isLineupsTracked) {
    const webcomp = document.getElementsByTagName(matchLineupsFieldsWidgetTag)[0];
    const isFormationsActive = isFormationsTabActive();
    if (webcomp && isFormationsActive) {
      analyticsTrack(MATCH_LINEUPS_FIELDS_WIDGET_TRACKING_KEY)
        .then((value) => {
          console.log('[analytics-track.ts]', MATCH_LINEUPS_FIELDS_WIDGET_TRACKING_KEY, { value }); // eslint-disable-line no-console
          isLineupsTracked = value;
        })
        .catch((err) => console.warn('[analytics-track.ts]', MATCH_LINEUPS_FIELDS_WIDGET_TRACKING_KEY, err)); // eslint-disable-line no-console
      console.info('[track-web-components.ts] trackLineupsComponent - hasTracked:', isLineupsTracked); // eslint-disable-line no-console
    }
  } else {
    console.info('[track-web-components.ts] trackLineupsComponent - lineups already tracked'); // eslint-disable-line no-console
  }
};
